import COM from "./Video";

export default COM;


// WEBPACK FOOTER //
// ./src/js/components/Video/index.js